import { apiConcurso } from './cliente';

// Token e X-Tenant-Slug vêm do cliente (api/cliente.js).
export const getCEP = (cep) => apiConcurso.get(`/api/v1/utils/cep/${cep}`);
